import React, { useRef, useCallback, useState, useEffect } from "react";
import PortfolioUploading from "./PortfolioUploading";
import { Field } from "formik";
import { useSelector, useDispatch } from "react-redux";
import { updatePostData } from "../../../../Redux/Slice/createPostSlice";
import {
  BUSINESS_FORM_ACTION_ROW_BETWEEN_CLASS,
} from "../../shared/businessLayoutSpec";
import {
  AdminHeaderAction,
  AdminLinkAction,
  AdminFormFieldError,
} from "../../../AdminDashboard/shared/adminUx";

const PortfolioSection = ({ setStep, setFieldValue, values, handlePost }) => {
  const dispatch = useDispatch();
  const postData = useSelector((state) => state.createPost);
  const userPlan = useSelector((state) => state.user?.user?.userPlan?.plan?.name || "basic");
  const [isUpdating, setIsUpdating] = useState(false);
  const portfolioImagesRef = useRef(useSelector((state) => state.createPost.portfolioImages) || []);

  const getMaxFiles = () => {
    switch (userPlan.toLowerCase()) {
      case "pro":
        return 5;
      case "basic":
      default:
        return 2;
    }
  };

  const handleNextClick = () => {
    if (portfolioImagesRef.current && portfolioImagesRef.current.length > 0) {
      setIsUpdating(true);
    }
  };

  useEffect(() => {
    if (isUpdating && postData.portfolioImages?.length > 0) {
      handlePost();
      setIsUpdating(false);
      setStep(7);
    }
  }, [isUpdating, postData.portfolioImages]);

  const handleImageListChange = useCallback(
    (newImages) => {
      if (Array.isArray(newImages)) {
        portfolioImagesRef.current = newImages;
        setFieldValue("portfolioImages", newImages);
        dispatch(updatePostData({ portfolioImages: newImages }));
      } else if (typeof newImages === "function") {
        const uploadedImages = newImages();
        if (uploadedImages && uploadedImages.length > 0) {
          const processedImages = uploadedImages.map((img) => ({
            name: img.name || img.filename || "image",
            url: img.url || img,
          }));
          portfolioImagesRef.current = [...portfolioImagesRef.current, ...processedImages];
          setFieldValue("portfolioImages", portfolioImagesRef.current);
          dispatch(updatePostData({ portfolioImages: portfolioImagesRef.current }));
        }
      }
    },
    [dispatch, setFieldValue]
  );

  return (
    <>
      <div className="w-full">
        <Field name="portfolioImages">
          {({ form }) => (
            <>
              <PortfolioUploading
                setImageList={handleImageListChange}
                ImageList={portfolioImagesRef.current}
                maxFiles={getMaxFiles()}
              />
              {form.errors.portfolioImages && (
                <AdminFormFieldError className="mt-2">
                  {form.errors.portfolioImages}
                </AdminFormFieldError>
              )}
            </>
          )}
        </Field>
      </div>

      <div className={BUSINESS_FORM_ACTION_ROW_BETWEEN_CLASS}>
        <AdminLinkAction type="button" onClick={() => setStep(5)}>
          Back
        </AdminLinkAction>
        <AdminHeaderAction
          type="button"
          onClick={handleNextClick}
          disabled={!portfolioImagesRef.current || portfolioImagesRef.current.length === 0}
        >
          Next
        </AdminHeaderAction>
      </div>
    </>
  );
};

export default PortfolioSection;
